<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="workUnit.pkId ? '编辑' : '新建'"
    width="600px"
    @close="$reset('form')"
  >
    <el-form ref="form" :model="workUnit" :rules="ruleValidate" class="form" label-width="100px">
      <el-form-item v-if="workUnit.pkId" label="工作单元编号">
        <el-input v-model="workUnit.workUnitNo" disabled placeholder="请输入工作单元编号" clearable />
      </el-form-item>
      <el-form-item label="工作单元名称" prop="workUnitName">
        <el-input v-model="workUnit.workUnitName" placeholder="请输入工作单元名称" clearable />
      </el-form-item>
      <el-form-item label="所属生产中心" prop="workCenterName">
        <el-input v-model="workUnit.workCenterName" readonly placeholder="请选择所属生产中心">
          <el-button slot="append" @click="$refs.selectWorkCenter.open()" icon="el-icon-search"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
    <work-center-select ref="selectWorkCenter" @select="onSelectWorkCenter" />
  </el-dialog>
</template>

<script>
import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
export default {
  name: "WorkUnitEdit",
  components: { WorkCenterSelect },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      workUnit: {
        workUnitName: "",
        workCenterName: "",
      },
      ruleValidate: {
        workCenterName: { required: true, message: "请选择所属生产中心", trigger: "change" },
        workUnitName: { required: true, message: "请输入工作单元名称", trigger: "blur" },
      },
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      if (row) {
        this.workUnit = Object.assign(this.workUnit, row);
      }
    },

    // 编辑、新建
    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "workUnits", this.workUnit)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                if (this.workUnit.pkId > 0) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },

    // 选择生产中心
    onSelectWorkCenter(row) {
      this.workUnit.workCenterId = row.pkId;
      this.workUnit.workCenterName = row.workCenterName;
    },
  },
};
</script>
